<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <a-row type="flex" justify="space-between" style="background: #2B9ED6;" align="middle">
      <a-col :xs="5" :sm="16" :md="16" :lg="19" :xl="19">
        <a-row type="flex" justify="start" align="middle">
          <a-col>
            <a-row  type='flex' justify="start" align="middle">
              <a-col class="ml10">
                <img src="../../assets/img/icontitle_4.png"/>
              </a-col>
              <!--               <a-col  class="ml4 logoClass">eCWMS 2.0</a-col>-->
            </a-row>
          </a-col>
          <a-col :span="18" id="topMenuBuju2"  class="ml4">
            <a-menu
                    v-if="userMenu.length > 0"
                    mode="horizontal"
                    :subMenuCloseDelay="20"
                    :subMenuOpenDelay="10"
                    theme="dark"
                    @openChange="onOpenChange">



              <template v-for="(item,index) in userMenu">
                <a-sub-menu :key="item.key"  @titleClick="selectMenuApi(item)">
                  <a-row slot="title" style="padding: 10px 0;" class="topMenuLiClass" :class="[index == 0 ?'topMenuNoBorder':'']">
                    <img
                            v-if="item.funcCode == 'Home' || item.funcCode == 'blankHome' "
                            class="menuImgClass"
                            src="../../assets/img/mainhome.png"
                            alt=""
                    />


                    <img
                            v-if="item.funcCode == 'M_GENE'"
                            class="menuImgClass"
                            src="../../assets/img/generic.png"
                            alt=""
                    />
                    <img
                            v-if="item.funcCode == 'M_MS_DATA'"
                            class="menuImgClass"
                            src="../../assets/img/mainMasterData.png"
                            alt=""
                    />
                    <img
                            v-if="item.funcCode == 'M_SYS'"
                            class="menuImgClass"
                            src="../../assets/img/mainsystems.png"
                            alt=""
                    />
                    <img
                            v-if="item.funcCode == 'M_INB'"
                            class="menuImgClass"
                            src="../../assets/img/mainInbound.png"
                            alt=""
                    />
                    <img
                            v-if="item.funcCode == 'M_OUTB'"
                            class="menuImgClass"
                            src="../../assets/img/mainOutbound.png"
                            alt=""
                    />
                    <img
                            v-if="item.funcCode == 'M_INV'"
                            class="menuImgClass"
                            src="../../assets/img/maininventory.png"
                            alt=""
                    />
                    <img
                            v-if="item.funcCode == 'M_TMS'"
                            class="menuImgClass"
                            src="../../assets/img/tms.png"
                            alt=""
                    />
                    <img
                            v-if="item.funcCode == 'SUPPORT'"
                            class="menuImgClass"
                            src="../../assets/img/tms.png"
                            alt=""
                    />
                    <img
                               v-if="item.funcCode == 'M_CFS'"
                               class="menuImgClass"
                               src="../../assets/img/cfs.png"
                               alt=""
                       />
                       <img
                             v-if="item.funcCode == 'M_MOBILE'"
                             class="menuImgClass"
                             src="../../assets/img/cfs.png"
                             alt=""
                       />
                       <img
                               v-if="item.funcCode == 'M_REPORT'"
                               class="menuImgClass"
                               src="../../assets/img/ss-report.png"
                               style="margin-bottom: -2px;"
                               alt=""
                       />

                    <img
                            v-if="item.funcCode == 'M_EDI'"
                            class="menuImgClass"
                            src="../../assets/img/ss-report.png"
                            style="margin-bottom: -2px;"
                            alt=""
                    />
                    <a-row class="menuTitleClass">
                      {{ item.funcName }}
                    </a-row>
                  </a-row>
                  <a-menu-item
                          v-for="menuItem in item.children"
                          :key="menuItem.key"
                          @click="selectMenuApi(menuItem)"
                  >{{ menuItem.funcName }}</a-menu-item>
                </a-sub-menu>
                <!-- <a-menu-item v-else :key="item.key" @click="selectMenuApi(item)">
                  <a-row style="padding: 10px 0; text-align: center;">
                    <img src="../../assets/img/mainhome.png" alt="" style="display: block;width: 20px;height: 20px;margin: 0px auto;"/>
                    <a-row style="line-height: 10px;margin-top: 18px;font-size: 12px;">
                      {{ item.funcName }}
                    </a-row>
                  </a-row>
                </a-menu-item> -->
              </template>




            </a-menu>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="5">
        <a-row type="flex" justify="end" align="middle">
          <a-col>
            <a-icon type="user" class="mr4" style="font-size: 18px;color: #fff"/>
            <a-dropdown >
              <a class="ant-dropdown-link mr4"  :style="{color: seetingPage.typeBuju ? '#FFFFFF':'#fff'}">{{ projectModelcheck == null ? '......':  projectModelcheck == '' ? '.....': projectModelcheck | SubLength }}</a>
              <a-menu slot="overlay" v-if="userMenu.length > 0">
                <a-menu-item style="font-size: 12px;"><a-icon type="save" />  {{ projectModelcheck == null ? '......':  projectModelcheck == '' ? '.....': projectModelcheck }}</a-menu-item>
                <a-menu-item
                        @click="projectModel"
                        style="font-size: 12px;border-bottom: 1px solid #efefef"
                ><a-icon type="project" />{{$t('publicLang.ProjectandWarehouse')}}</a-menu-item>
                <a-menu-item style="font-size: 12px;"><a-icon type="save" />{{ userInfo.user }} </a-menu-item>
                <a-menu-item style="font-size: 12px;" @click="ChangeAliasName"><a-icon type="unlock" />{{ $t('login.ResetAliasName') }}</a-menu-item>
                <a-menu-item style="font-size: 12px;" @click="ResetPassWord"><a-icon type="unlock" />{{ $t('login.ResetPassword') }}</a-menu-item>
                <a-sub-menu key="test">
                  <span slot="title"><a-icon type="global" style="margin-right: 4px;" />{{LanguageText}}</span>
                  <a-menu-item
                          v-for="(item, index) in langList"
                          @click="changeLang(item)"
                          style="font-size: 12px;border-bottom: 1px solid #efefef"
                  >{{ item.val }}</a-menu-item
                  >
                </a-sub-menu>
                <a-menu-item
                        @click="getliulanInfo"
                        style="font-size: 12px"
                ><a-icon type="info" />{{$t('menu.PerformanceFeedback')}}</a-menu-item>
                <a-menu-item
                        @click="loginMark"
                        style="font-size: 12px"
                        v-if="userInfo.loginMark"
                ><a-icon type="info" />{{$t('menu.SimulateUser')}}</a-menu-item>
                <a-menu-item
                        @click="logoutMark"
                        v-if="userInfo.logoutMark"
                        style="font-size: 12px;border-bottom: 1px solid #efefef"
                ><a-icon type="info" />{{$t('menu.ReleaseUser')}}</a-menu-item>

                <a-menu-item
                        @click="printNodeMenuItem"
                        style="font-size: 12px;border-bottom: 1px solid #efefef"
                ><a-icon type="info" />{{$t('menu.PrintNode')}}</a-menu-item>

                <a-menu-item
                        @click="outLogin"
                        style="font-size: 12px;border-bottom: 1px solid #efefef"
                ><a-icon type="poweroff" />{{$t('menu.Logout')}}</a-menu-item>

                 <a-menu-item @click="releaseNotes" style="font-size: 12px;"><a-icon type="save" />{{systemVersion}}</a-menu-item>
              </a-menu>
            </a-dropdown>
          </a-col>
          <a-col class="mlr15">
            <a-row type="flex" justify="center" align="middle">
              <info-com :seetingPageTypeBuju="seetingPage.typeBuju"  ref="infoCom"></info-com>
            </a-row>
            <a-row justify="center" align="middle" style="color: #fff;font-size: 12px;">Notification</a-row>
          </a-col>
          <a-col class="mr10">
            <a-row type="flex" justify="center" align="middle" style="margin-bottom: 4px;">
              <img @click="pageSettingClass" class='sbxs' src="../../assets/img/ss-setting1.png" width="20" height="20">
            </a-row>
            <a-row justify="center" align="middle" style="color: #fff;font-size: 12px">System</a-row>
          </a-col>
        </a-row>
      </a-col>
    </a-row>

    <a-layout-content class="layout-content">
      <a-row>
        <a-tabs
                hideAdd
                v-model="activeKey"
                type="editable-card"
                @edit="onEdit"
                ref="tabHeight"
                @tabClick="TopTabClick"
                size="small"
                v-if="panes.length > 0"
                :tabBarStyle="tabBarStyle"
                class="pageTopMenu"
        >
          <a-tab-pane
                  v-for="pane in panes"
                  :key="pane.key"
                  :closable="pane.closable"
          >
            <span slot="tab">
               <a-tooltip placement="topLeft">
                  <template slot="title">
                    <span>{{ pane.funcName }}</span>
                  </template>
                   <span>{{ pane.funcName | SubLength }}</span>
                </a-tooltip>
            </span>
          </a-tab-pane>
        </a-tabs>
      </a-row>
      <!--每次请求loading-->
      <div class="loadingbtnCom" v-if="pbLoading">
        <a-spin tip="Loading..."></a-spin>
      </div>
      <keep-alive v-if="userMenu.length > 0">
        <router-view ref="viewFun" @updatePanes="updatePanes"  @showNotification="showNotification"></router-view>
      </keep-alive>

      <a-row style="margin: 0 auto;margin-top: 25vh;text-align: center;" v-else>
        <a-row>
          <a-icon type="exclamation-circle" style="font-size: 45px;color: #faad14;"/>
        </a-row>
        <a-row style="margin: 25px;color:red;font-size: 16px;">
          {{ $t('publicLang.theIstAdministrator')}}
        </a-row>
        <a-row>
          <a-button type="primary" key="console">
            <router-link to="/login" size="small">{{ $t('publicLang.PubOk')}}</router-link>
          </a-button>
        </a-row>
      </a-row>
    </a-layout-content>
    <!--project 选择-->
    <a-modal
            :title="$t('publicLang.ProjectandWarehouse')"
            v-model="projectVisble"
            width="35%"
            :maskClosable="closable"
    >
      <template slot="footer">
        <a-button type="primary" @click="projectChange">{{ $t('publicLang.Save') }}</a-button>
      </template>
      <a-form :form="projectForm">
        <a-row>
          <a-col :span="24">
            <a-form-item v-bind="formItemLayout" :label="$t('roleGe.Project')">
              <a-select
                      style="width: 100%"
                      @change="projectSelectChange"
                      size="small"
                      :placeholder="$t('publicLang.PleaseSelect')"
                      show-search
                      option-filter-prop="children"
                      :filter-option="projectFilterOption"
                      v-decorator="[
                      'selectProjectModelcheck',
                      {
                        initialValue:selectProjectModelcheck,
                        rules: [{ required: true, message: $t('publicLang.Required') }]
                      }
                    ]">
                <a-select-option
                        v-for="item in userInfo.projectCodeList"
                        :key="item.projectCode"
                        :value="item.projectCode"
                        :label="item.displayName"
                >{{ item.displayName }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item v-bind="formItemLayout" :label="$t('userlang.Warehouse')">
              <a-select
                      style="width: 100%"
                      size="small"
                      :placeholder="$t('publicLang.PleaseSelect')"
                      show-search
                      v-decorator="[
                      'projectWarehouseCode',
                      {
                        initialValue:projectWarehouseCode,
                        rules: [{ required: true, message: $t('publicLang.Required') }]
                      }
                    ]" :disabled="true" class="statusbtn">
                <a-select-option v-for="item in userInfo.warehouseList" :value="item.whsCode" >{{item.whsName}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <!--loginMark 选择-->
    <a-modal
            :title="$t('menu.SimulateUser')"
            v-model="loginMarkVis"
            width="35%"
            :maskClosable="closable"
    >
      <template slot="footer">
        <a-button type="primary" @click="loginMarkSubMint">{{ $t('publicLang.Save') }}</a-button>
      </template>
      <a-cascader
              v-model="loginMarkValue"
              style="width: 100%;"
              :options="loginMarkArr"
              :loadData="loginMarkLoadData"
              :placeholder="$t('publicLang.PleaseSelect')"
              :fieldNames="{ value: 'key', label: 'value', children: 'children' }"
      />
    </a-modal>
    <!--PrintNode 选择-->
    <a-modal
            :title="$t('menu.PrintNode')"
            v-model="printNode"
            width="35%"
            :maskClosable="closable"
            :zIndex='999'
    >
      <template slot="footer">
        <a-button type="primary" @click="printNodeSubmit" size="small">{{ $t('publicLang.Save') }}</a-button>
      </template>
      <a-row>
        <a-cascader
                size="small"
                v-model="printNodeValue"
                style="width: 100%;"
                :options="printNodeArr"
                :loadData="printNodeData"
                placeholder="Please select"
                :fieldNames="{ value: 'key', label: 'value', children: 'children' }"
        />
      </a-row>
    </a-modal>
    <!--第一次填写登录详情-->
    <a-modal
            :title="$t('login.registerForm')"
            v-model="validateLoginVisble"
            width="60%"
            :closable="closable"
            :maskClosable="closable"
    >
      <template slot="footer">
        <a-button type="primary" @click="validateSubnit">{{ $t('publicLang.Save') }}</a-button>
      </template>
      <a-form :form="validateLogin">
        <a-row :gutter="24" style="margin-top: 20px">
          <a-col :span="12">
            <a-form-item v-bind="formItemLayout" :label="$t('menu.FirstName')">
              <a-input
                      autocomplete="off"
                      style="width: 100%"
                      :placeholder="$t('menu.FirstName')"
                      v-decorator="[
                  'firstName',
                  { rules: [{ required: true, message: $t('publicLang.Required') }] }
                ]"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item v-bind="formItemLayout" :label="$t('menu.LastName')">
              <a-input
                      :placeholder="$t('menu.LastName')"
                      autocomplete="off"
                      style="width: 100%"
                      v-decorator="[
                  'lastName',
                  { rules: [{ required: true, message: $t('publicLang.Required') }] }
                ]"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item v-bind="formItemLayout" :label="$t('menu.DisplayName')">
              <a-input
                      :placeholder="$t('menu.DisplayName')"
                      autocomplete="off"
                      style="width: 100%"
                      v-decorator="['dispName',{ rules: [{ required: true, message: $t('publicLang.Required') }] }]"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item v-bind="formItemLayout" :label="$t('menu.MiddleName')">
              <a-input
                      :placeholder="$t('menu.MiddleName')"
                      autocomplete="off"
                      style="width: 100%"
                      v-decorator="['middleName']"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item v-bind="formItemLayout" :label="$t('menu.Email')">
              <a-input
                      :placeholder="$t('menu.Email')"
                      v-decorator="[
                    'email',
                    {
                      initialValue:validateDataEdit,
                      rules: [
                        {
                          type: 'email',
                          message: $t('publicLang.PleaseinputEmail')
                        },
                        {
                          required: true,
                          message: $t('publicLang.PleaseinputEmail')
                        },],},]"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('menu.Department')" v-bind="formItemLayout">
              <a-input
                      autocomplete="off"
                      style="width: 100%"
                      :placeholder="$t('menu.Department')"
                      v-decorator="[
                  'departName',
                  { rules: [{ required: false, message: $t('publicLang.Required') }] }
                ]"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('menu.Position')" v-bind="formItemLayout">
              <a-input
                      autocomplete="off"
                      style="width: 100%"
                      :placeholder="$t('menu.Position')"
                      v-decorator="[
                  'position',
                  { rules: [{ required: false, message: $t('publicLang.Required') }] }
                ]"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('menu.Telephone')" v-bind="formItemLayout">
              <a-input
                      autocomplete="off"
                      style="width: 100%"
                      :placeholder="$t('menu.Telephone')"
                      v-decorator="['telNum']"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('menu.City')" v-bind="formItemLayout">
              <a-cascader
                      v-model="cityArr"
                      :options="cityOptions"
                      @change="cityChange"
                      :loadData="cityLoadData"
                      :placeholder="$t('publicLang.PleaseSelect')"
                      changeOnSelect
                      :fieldNames="{ value: 'ebplCode', label: 'ebplNameEn', children: 'children' }"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('menu.TimeZone')" v-bind="formItemLayout">
              <a-select
                      style="width: 100%"
                      allowClear
                      :placeholder="$t('publicLang.PleaseSelect')"
                      v-decorator="[
                  'timeZone',
                  {
                    rules: [{ required: true, message: $t('publicLang.Required') }]
                  }
                ]">
                <a-select-option
                        v-for="(ii, index) in timeZoneSelect"
                        :value="ii.key"
                        :key="index"
                >{{ ii.englishName }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('menu.DefaultLanguage')" v-bind="formItemLayout">
              <a-select
                      style="width: 100%"
                      allowClear
                      :placeholder="$t('publicLang.PleaseSelect')"
                      v-decorator="[
                  'defaultLang',
                  {
                    initialValue: '2',
                    rules: [{ required: true, message: $t('publicLang.Required') }]
                  }
                ]">
                <a-select-option value="0">{{ $t('userlang.Jtlang') }}</a-select-option>
                <a-select-option value="1">{{ $t('userlang.ftlang') }}</a-select-option>
                <a-select-option value="2">English</a-select-option>
                <a-select-option value="3">{{ $t('userlang.korlang') }}</a-select-option>
                <a-select-option value="4">{{ $t('userlang.thlang') }}</a-select-option>
                <a-select-option value="5">{{ $t('userlang.jplang') }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
            <a-col :span="12">
              <a-form-item :label="$t('login.Username')" v-bind="formItemLayout">
                <a-input
                        autocomplete="off"
                        style="width: 100%"
                        :placeholder="$t('publicLang.PleaseEnter')"
                        v-decorator="[
                      'username',
                    ]"/>
              </a-form-item>
            </a-col>
        </a-row>
      </a-form>
    </a-modal>

    <a-modal
            title="Change Alias Name"
            v-model="ChangeAliasNameVis"
            width="45%"
            :maskClosable="closable"
            @cancel="cancelChangeAliasName">
      <template slot="footer">
        <a-button type="primary" @click="SaveAliasName">{{ $t('publicLang.Save') }}</a-button>
      </template>
      <a-row>
        <a-form>
          <a-form-item :label="$t('login.ChangeAliasName')" v-bind="formItemLayout">
            <a-input
                    size="small"
                    type="text"
                    v-model="aliasNameVal"
                    :placeholder="$t('publicLang.PleaseEnter')"/>
          </a-form-item>
        </a-form>
      </a-row>
    </a-modal>
    <a-modal
        :title="$t('login.firstLoginChangePassword')"
        v-model="FirstResetPassWordVis"
        width="45%"
        :keyboard="false"
        :closable="false"
        :maskClosable="false"
    >
      <template slot="footer">
        <a-button type="primary" @click="SaveFirstResetPass">{{ $t('publicLang.Save') }}</a-button>
        <a-button type="primary" style="background-color: #757575; border-color: #757575; color: #ffffff;" @click="outLogin">{{ $t('menu.Logout') }}</a-button>
      </template>
      <a-row>
        <a-form>
          <a-row>
          </a-row>
          <a-form-item :label="$t('login.OldPassword')" v-bind="formItemLayout">
            <a-input
                id="passOldFirstVal"
                size="small"
                :style="{borderColor: FirstResetPass.ResetOld ? 'red' : '#d9d9d9'}"
                type="password"
                v-model="FirstResetPass.passOldVal"
                :placeholder="$t('publicLang.PleaseEnter')"
                @change="changeIputFirstPassWord('old')"/>
          </a-form-item>
          <a-form-item :label="$t('login.NewPassword')" v-bind="formItemLayout">
            <a-input
                id="passNewFirstVal"
                size="small"
                :style="{borderColor: FirstResetPass.ResetNew ? 'red' : '#d9d9d9'}"
                type="password"
                v-model="FirstResetPass.passNewVal"
                :placeholder="$t('publicLang.PleaseEnter')"
                @change="changeIputFirstPassWord('new')"/>
            <div class="infoError" v-if="FirstResetPass.ResetNew">
              <span v-if="isOldNew">
                 {{ $t('login.passWordError1') }}<br>{{ $t('login.passWordError2') }}<br>&nbsp;&nbsp;{{$t('login.passWordError3')}}<br>&nbsp;&nbsp;{{$t('login.passWordError4')}}<br>&nbsp;&nbsp;{{ $t('login.passWordError5') }}<br>&nbsp;&nbsp;{{ $t('login.passWordError6') }}
              </span>
              <span v-else>{{ $t('login.NewpasswordNotoldPassword') }}</span>
            </div>
          </a-form-item>
          <a-form-item :label="$t('login.ConfirmNewPassword')" v-bind="formItemLayout">
            <a-input
                size="small"
                :style="{borderColor: FirstResetPass.ResetConfirm ? 'red' : '#d9d9d9'}"
                type="password"
                v-model="FirstResetPass.passConfirmVal"
                :placeholder="$t('publicLang.PleaseEnter')"
                @change="changeIputFirstPassWord('Confirm')"
            />
            <div class="infoError" v-if="FirstResetPass.ResetConfirm">{{  $t('login.TwopasswordsInconsistent') }}</div>
          </a-form-item>
        </a-form>

      </a-row>
    </a-modal>
    <!--重置密码-->
    <a-modal
          :title="$t('login.ResetPassword')"
            v-model="ResetPassWordVis"
            width="45%"
            :maskClosable="closable"
            @cancel="cancelResetPassWord"
    >
      <template slot="footer">
        <a-button type="primary" @click="SaveResetPass">{{ $t('publicLang.Save') }}</a-button>
      </template>
      <a-row>
        <a-form>
          <a-row>
          </a-row>
          <a-form-item :label="$t('login.OldPassword')" v-bind="formItemLayout">
            <a-input
                   id="passOldVal"
                    size="small"
                    :style="{borderColor: ResetPass.ResetOld ? 'red' : '#d9d9d9'}"
                    type="password"
                    v-model="ResetPass.passOldVal"
                    :placeholder="$t('publicLang.PleaseEnter')"
                    @change="changeIputPassWord('old')"/>
          </a-form-item>
          <a-form-item :label="$t('login.NewPassword')" v-bind="formItemLayout">
            <a-input
                    id="passNewVal"
                    size="small"
                    :style="{borderColor: ResetPass.ResetNew ? 'red' : '#d9d9d9'}"
                    type="password"
                    v-model="ResetPass.passNewVal"
                    :placeholder="$t('publicLang.PleaseEnter')"
                    @change="changeIputPassWord('new')"/>
            <div class="infoError" v-if="ResetPass.ResetNew">
              <span v-if="isOldNew">
                 {{ $t('login.passWordError1') }}<br>&nbsp;&nbsp;{{$t('login.passWordError3')}}<br>&nbsp;&nbsp;{{$t('login.passWordError4')}}<br>&nbsp;&nbsp;{{ $t('login.passWordError5') }}<br>&nbsp;&nbsp;{{ $t('login.passWordError6') }}
              </span>
              <span v-else>{{ $t('login.NewpasswordNotoldPassword') }}</span>
            </div>
          </a-form-item>
          <a-form-item :label="$t('login.ConfirmNewPassword')" v-bind="formItemLayout">
            <a-input
                    size="small"
                    :style="{borderColor: ResetPass.ResetConfirm ? 'red' : '#d9d9d9'}"
                    type="password"
                    v-model="ResetPass.passConfirmVal"
                    :placeholder="$t('publicLang.PleaseEnter')"
                    @change="changeIputPassWord('Confirm')"
            />
            <div class="infoError" v-if="ResetPass.ResetConfirm">{{  $t('login.TwopasswordsInconsistent') }}</div>
          </a-form-item>
        </a-form>

      </a-row>
    </a-modal>


    <a-modal
        :title="$t('login.PasswordExpiryWarning')"
        v-model="passwordExpiryVisible"
        width="400px"
        :closable="true"
        :maskClosable="false"
        @cancel="closePasswordExpiryModal"
    >
      <template slot="footer">
        <a-button type="primary" @click="closePasswordExpiryModal">{{ $t('publicLang.PubOk') }}</a-button>
      </template>
      <div style="text-align: center; padding: 20px 0;">
        <a-icon type="exclamation-circle" style="font-size: 48px; color: #faad14; margin-bottom: 16px;" />
        <p style="font-size: 16px; margin-bottom: 8px;">
          {{ $t('login.PasswordExpiryMessage') }}
        </p>
        <p style="font-size: 18px; font-weight: bold; color: #f5222d;">
          <span v-if="passwordExpiryDays <= 0">{{ $t('login.PasswordExpiredToday') }}</span>
          <span v-else>{{ $t('login.PasswordExpiryDaysLeft').replace('{days}', passwordExpiryDays) }}</span>
        </p>
        <!--        <p style="font-size: 14px; color: #666; margin-top: 16px;">-->
        <!--          {{ $t('login.PleaseChangePasswordImmediately') }}-->
        <!--        </p>-->
      </div>
    </a-modal>

    <a-drawer
            :title="$t('publicLang.StyleSetting')"
            placement="right"
            :visible="pageSettingVis"
            @close="closePageSettingVis"
    >
      <a-row>
        <!--<p>{{ $t('publicLang.NavigationMode') }}</p>-->
        <!--<a-row class="mt4">-->
        <!--&lt;!&ndash;<a-col :span="5" style="position: relative;">&ndash;&gt;-->
        <!--&lt;!&ndash;<a-tooltip placement="top">&ndash;&gt;-->
        <!--&lt;!&ndash;<template slot="title">&ndash;&gt;-->
        <!--&lt;!&ndash;<span>{{ $t('publicLang.LeftLayout') }}</span>&ndash;&gt;-->
        <!--&lt;!&ndash;</template>&ndash;&gt;-->
        <!--&lt;!&ndash;<img src="../../assets/img/LCkqqYNmvBEbokSDscrm.svg" class="sbxs"  @click="() => (seetingPage.typeBuju = true)">&ndash;&gt;-->
        <!--&lt;!&ndash;<a-icon type="check" class="seetingbujiChek" v-show="seetingPage.typeBuju"/>&ndash;&gt;-->
        <!--&lt;!&ndash;</a-tooltip>&ndash;&gt;-->
        <!--&lt;!&ndash;</a-col>&ndash;&gt;-->
        <!--<a-col :span="5" class='ml10' style="position: relative;">-->
        <!--<a-tooltip placement="top">-->
        <!--<template slot="title">-->
        <!--<span>{{ $t('publicLang.TopLayout') }}</span>-->
        <!--</template>-->
        <!--<img src="../../assets/img/KDNDBbriJhLwuqMoxcAr.svg" class="sbxs"  @click="() => (seetingPage.typeBuju = false)">-->
        <!--<a-icon type="check" class="seetingbujiChek"  v-show="!seetingPage.typeBuju"/>-->
        <!--</a-tooltip>-->
        <!--</a-col>-->
        <!--</a-row>-->
        <a-row>
          <p class="mtb8">Zoom Size</p>
          <a-slider v-model="seetingPage.pageZoom" :min="100" :max="200" @change="pageZoomChange"/>
        </a-row>
        <a-row>
          <a-row style="background: #efefef;padding: 10px;"  v-if="false">
            <colorPicker v-model="pubcColor" v-on:change="headleChangeColor" style="border: 1px solid #8c8c8c;"/>
          </a-row>
        </a-row>
      </a-row>
    </a-drawer>

    <lpn-print ref="lpnPrintRef"></lpn-print>
    <qr-code ref="qrCodeRef"></qr-code>
    <convert-count-result ref="convertCountResultRef"></convert-count-result>
    <print-price-label ref="printPriceLabel"></print-price-label>
    <scan-in ref="scanInRefs"></scan-in>
    <scan-pack ref="scanpackRefs"></scan-pack>
    <consolidation ref="consolidationRefs"></consolidation>
    <cfs-scan-in ref="cfsScanInRefs"></cfs-scan-in>
    <cfs-scan-pack ref="cfsScanPackRefs"></cfs-scan-pack>
    <cfs-scan-load ref="cfsScanLoadRefs"></cfs-scan-load>
    <lane-crawford-form ref="laneCrafmRef"></lane-crawford-form>
    <scan-to-print-window ref="scanToPrintWindow"></scan-to-print-window>
    <split-scan ref="splitScanRef"></split-scan>
    <scan-pack-pick-to-zero ref="scanPackPickToZero"></scan-pack-pick-to-zero>
  </a-layout>
</template>
<script>
  import ajax from "../../api/ajax";
  import api from "../../api/url";
  import { mapState } from "vuex";
  import sessionManager from "../../utils/session-manager";
  import cookie from "../../api/cookie";
  import lpnPrint from '../masterData/custPage/lpnPrint.vue'
  import qrCode from '../masterData/custPage/qrCode.vue'
  import convertCountResult from '../masterData/custPage/convertCountResult.vue'
  import printPriceLabel from '../masterData/custPage/printPriceLabel.vue'
  import infoCom from './info.vue'
  import scanIn from '../masterData/custPage/scanIn.vue'
  import scanPack from '../masterData/custPage/scanpack.vue'
  import consolidation from '../masterData/custPage/consolidation.vue'
  import cfsScanPack from '../masterData/custPage/cfsScanPack.vue'
  import cfsScanLoad from "../masterData/custPage/cfsScanLoad";
  import laneCrawfordForm from './laneCrawfordForm.vue';
  import cfsScanIn from "../masterData/custPage/cfsScanIn";
  import scanToPrintWindow from "../masterData/custPage/scanToPrintWindow.vue";
  import splitScan from '../masterData/custPage/splitScan.vue'
  import scanPackPickToZero   from '../masterData/custPage/scanPackPickToZero'
  import moment from "moment";
  import encrypt from "@assets/js/encrypt-DES";
  import store from "../../store";
  import axios from "axios";
  export default {
    components: {
      lpnPrint,
      qrCode,
	  convertCountResult,
      printPriceLabel,
      infoCom,
      scanIn,
      scanPack,
      consolidation,
      cfsScanIn,
      cfsScanPack,
      cfsScanLoad,
      laneCrawfordForm,
      scanToPrintWindow,
	    splitScan,
      scanPackPickToZero
    },
    data() {
      return {
        pubcColor: '#fffff',
        pageSettingVis: false,
        seetingPage:{
          typeBuju: false,
          pageZoom: 100
        },

        menuOpenKeys: [],
        rootSubmenuKeys: [],
        printNode: false,
        printNodeValue: [],
        printNodeArr: [],

        leftMenuActive: '0',
        loginMarkVis: false,
        loginMarkArr: [],
        loginMarkValue: [],
        spinning: true,
        tabBarStyle: {
          border: "none"
        },
        projectVisble: false,
        visiblePopover: false,
        langList: [
          { lang: "0", val: "简体中文" },
          { lang: "1", val: "繁体中文" },
          { lang: "2", val: "English" },
          { lang: "3", val: "한글" },
          { lang: "4", val: "ภาษาไทย" },
          { lang: "5", val: "日本語" }
        ], // 语言选中Array
        LanguageText: "简体中文", // 当前语言
        activeKey: "0",
        panes: [],
        newTabIndex: 0,
        collapsed: false,
        userMenu: [1],
        userInfo: "",
        validateLogin: this.$form.createForm(this),
        projectForm: this.$form.createForm(this),
        closable: false,
        validateLoginVisble: false,
        timeZoneSelect: [],
        projectModelcheck: null,
        formItemLayout: {
          labelCol: {
            xs: { span: 24 },
            sm: { span: 8 }
          },
          wrapperCol: {
            xs: { span: 24 },
            sm: { span: 16 }
          }
        }, // label 设置
        tokenTime: "",
        cityOptions: [],
        cityArr: [],
        validateDataEdit: '',
        selectProjectModelcheck: null,
        projectWarehouseCode: null, // project 下拉选中的值
        projectPageSize: 30,
        browser: {},
        printNodeWarehoseArr: [],
        printNodeNameArr: [],
        ResetPassWordVis: false, // 是否打开重置密码
        FirstResetPassWordVis: false,
        isOldNew: true,
        ResetPass:{
          ResetOld: false,
          ResetNew: false,
          ResetConfirm: false,
          passConfirmVal: "",
          passNewVal: "",
          passOldVal: ""
        },
        FirstResetPass:{
          ResetOld: false,
          ResetNew: false,
          ResetConfirm: false,
          passConfirmVal: "",
          passNewVal: "",
          passOldVal: ""
        },
        ChangeAliasNameVis: false,
        aliasNameVal:"",
        systemVersion: "",
        passwordExpiryVisible: false,
        passwordExpiryDays: 0
      };
    },
    filters: {
      userFilter(value) {
        if (value != undefined) {
          return value.length > 25 ? value.substr(0, 25) + "..." : value;
        }
      }
    },
    computed: {
      ...mapState(["lang"]),
      ...mapState(["ISVALIDATE"]),
      ...mapState(["iskeepLive"]),
      ...mapState(["pbLoading"])
    },
    inject: ["reload"],
    created() {
      this.userlogin();
      this.printNodeData11()
    },
    watch:{
      $route(val,old) {
        if(val.path == '/page'){
          this.userlogin();
        }
      },
    },
    methods: {
      showNotification(uid,type){
        this.$refs.infoCom.showNotificationByOrderUid(uid,type);
      },
      goCarfrom(){
        this.$refs.laneCrafmRef.show()
      },
      headleChangeColor(val){
      },
//            页面等比列缩放
      pageZoomChange(){
        document.body.style.zoom = this.seetingPage.pageZoom + '%'
      },
      pageSettingClass(){
        this.pageSettingVis = true
      },
      closePageSettingVis(){
        this.pageSettingVis = false
        sessionStorage.setItem("pageConfig", JSON.stringify(this.seetingPage));
      },

//            Change Alias Name start
      ChangeAliasName(){
        this.aliasNameVal = this.userInfo.aliasName
        this.ChangeAliasNameVis = true
      },
      cancelChangeAliasName(){
        this.ChangeAliasNameVis = false
      },
      SaveAliasName(){
        if (this.aliasNameVal == ''){
          this.$customMessage.warning("Alias Name can not be null.")
          return
        }
        if (this.aliasNameVal == this.userInfo.aliasName) {
          this.$message.success(this.$t('publicLang.UpdateSuccess'))
          this.ChangeAliasNameVis = false
          return
        }
        let params = {
          loginAcount: this.userInfo.currentUsername,
          aliasName: this.aliasNameVal
        }
        ajax.post(api.CHANGEALIASNAME,params).then(res=>{
          if (res.code == 200){
            this.userInfo.aliasName = params.aliasName
            this.$message.success(this.$t('publicLang.UpdateSuccess'))
            this.ChangeAliasNameVis = false
          } else {
            this.$message.success(res.msg)
          }
        })
      },
//            Change Alias Name end

//            重置密码 start
      cancelResetPassWord(){
        this.ResetPassWordVis = false
        this.ResetPass = {
          ResetOld: false,
          ResetNew: false,
          ResetConfirm: false,
          passConfirmVal: "",
          passNewVal: "",
          passOldVal: ""
        }
      },
      ResetPassWord(){
        this.ResetPass = {
          ResetOld: false,
          ResetNew: false,
          ResetConfirm: false,
          passConfirmVal: "",
          passNewVal: "",
          passOldVal: ""
        },
                this.ResetPassWordVis = true
      },
      changeIputPassWord(type){
        let pattern = new RegExp(/^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,64}$/)
        let val = ''
        if(type == 'old'){
          val = this.ResetPass.passOldVal
          if(val == ''){
            this.ResetPass.ResetOld = false
            return
          }
        }
        else if(type == 'new'){
          val = this.ResetPass.passNewVal
          if(val == ''){
            this.ResetPass.ResetOld = false
            return
          }
          if(this.ResetPass.passOldVal ==  this.ResetPass.passNewVal){
            this.ResetPass.ResetNew = true
            this.isOldNew = false
            return
          }else{
            this.isOldNew = true
          }
        }
        else if (type == 'Confirm'){
          if(this.ResetPass.passNewVal ==  this.ResetPass.passConfirmVal){
            this.ResetPass.ResetConfirm = false
            return
          }else{
            this.ResetPass.ResetConfirm = true
            return
          }
        }

        if(pattern.test(val)){
          if(type == 'old'){
            this.ResetPass.ResetOld = false
          }else{
            this.ResetPass.ResetNew = false
          }
        }else{
          if(type == 'old'){
            this.ResetPass.ResetOld = false
          }else{
            this.ResetPass.ResetNew = true
          }
        }
      },
//            提交
      SaveResetPass(){
        if(this.ResetPass.passOldVal == ''){
          this.ResetPass.ResetOld = true
          return
        }
        if(this.ResetPass.passNewVal == ''){
          this.ResetPass.ResetNew = true
          return
        }
        if(this.ResetPass.passConfirmVal == ''){
          this.ResetPass.ResetConfirm = true
          return
        }
        if(this.ResetPass.ResetOld || this.ResetPass.ResetNew || this.ResetPass.ResetConfirm || this.ResetPass.passNewVal == '' || this.ResetPass.passOldVal == '' ||  this.ResetPass.passConfirmVal == ''){
          return
        }
        let params = {
          username: this.userInfo.currentUsername
        }
        let utcTime = moment.utc().valueOf();
        params['newPassword'] = encrypt.encryptByDES( this.ResetPass.passNewVal,Math.floor(utcTime/ 30000).toString())
        params['ordPassword'] = encrypt.encryptByDES( this.ResetPass.passOldVal,Math.floor(utcTime/ 30000).toString())
        params['timestamp'] = utcTime;

        ajax.post(api.USERCHANGEPWD2,params).then(res=>{
          if(res.code == 200){
            this.ResetPassWordVis = false
            this.FirstResetPassWordVis = false
            sessionManager.showPasswordChangedModal().catch(() => {})
          }else if (res.code == 510){
            this.$customMessage.warning(res.msg,()=>{
              this.ResetPass.passOldVal = '';
              document.getElementById('passOldVal').focus();
            })
          }else {
            this.$customMessage.warning(res.msg,()=>{
              this.ResetPass.passNewVal = '';
              this.ResetPass.passConfirmVal = '';
              document.getElementById('passNewVal').focus();
            })
          }

        })
      },
      changeIputFirstPassWord(type){
        let pattern = new RegExp(/^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,64}$/)
        let val = ''
        if(type == 'old'){
          val = this.FirstResetPass.passOldVal
          if(val == ''){
            this.FirstResetPass.ResetOld = false
            return
          }
        }
        else if(type == 'new'){
          val = this.FirstResetPass.passNewVal
          if(val == ''){
            this.FirstResetPass.ResetOld = false
            return
          }
          if(this.FirstResetPass.passOldVal ==  this.FirstResetPass.passNewVal){
            this.FirstResetPass.ResetNew = true
            this.isOldNew = false
            return
          }else{
            this.isOldNew = true
          }
        }
        else if (type == 'Confirm'){
          if(this.FirstResetPass.passNewVal ==  this.FirstResetPass.passConfirmVal){
            this.FirstResetPass.ResetConfirm = false
            return
          }else{
            this.FirstResetPass.ResetConfirm = true
            return
          }
        }

        if(pattern.test(val)){
          if(type == 'old'){
            this.FirstResetPass.ResetOld = false
          }else{
            this.FirstResetPass.ResetNew = false
          }
        }else{
          if(type == 'old'){
            this.FirstResetPass.ResetOld = false
          }else{
            this.FirstResetPass.ResetNew = true
          }
        }
      },
      SaveFirstResetPass(){
        if(this.FirstResetPass.passOldVal == ''){
          this.FirstResetPass.ResetOld = true
          return
        }
        if(this.FirstResetPass.passNewVal == ''){
          this.FirstResetPass.ResetNew = true
          return
        }
        if(this.FirstResetPass.passConfirmVal == ''){
          this.FirstResetPass.ResetConfirm = true
          return
        }
        if(this.FirstResetPass.ResetOld || this.FirstResetPass.ResetNew || this.FirstResetPass.ResetConfirm || this.FirstResetPass.passNewVal == '' || this.FirstResetPass.passOldVal == '' ||  this.FirstResetPass.passConfirmVal == ''){
          return
        }
        let params = {
          username: this.userInfo.currentUsername
        }
        let utcTime = moment.utc().valueOf();
        params['newPassword'] = encrypt.encryptByDES( this.FirstResetPass.passNewVal,Math.floor(utcTime/ 30000).toString())
        params['ordPassword'] = encrypt.encryptByDES( this.FirstResetPass.passOldVal,Math.floor(utcTime/ 30000).toString())
        params['timestamp'] = utcTime;

        ajax.post(api.USERCHANGEPWD2,params).then(res=>{
          if(res.code == 200){
            this.FirstResetPassWordVis = false
            this.userInfo.firstLogin = "N"
            sessionManager.showPasswordChangedModal().then(() => {
              this.initializeValidateLoginForm(this.userInfo)
              this.validateLoginVisble = true
            }).catch(() => {})
          }else  if (res.code == 510){
            this.$customMessage.warning(res.msg,()=>{
              this.FirstResetPass.passOldVal = '';
              document.getElementById('passOldFirstVal').focus();
            })
          }else {
            this.$customMessage.warning(res.msg,()=>{
              this.FirstResetPass.passNewVal = '';
              this.FirstResetPass.passConfirmVal = '';
              document.getElementById('passNewFirstVal').focus();
            })
          }
        })
      },
//            重置密码 end
      onOpenChange(openKeys){
        const latestOpenKey = openKeys.find(key => this.menuOpenKeys.indexOf(key) === -1)
        if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
          this.menuOpenKeys = openKeys
        } else {
          this.menuOpenKeys = latestOpenKey ? [latestOpenKey] : []
        }
      },
      printNodeSubmit(){
        let unkey = localStorage.getItem('unkey')
        let timestamp = ''
        if(unkey == null){
          timestamp= Date.parse(new Date());
        }else{
          timestamp = unkey
        }

        let params = {
          uniqueName: timestamp
        }

        if(this.printNodeValue.length == 2){
          params.profileUid = this.printNodeValue[1]
        }
        ajax.post(api.PRINTNODEUNIQUENAME,params).then(res=>{
          if(res.code == 200){
            localStorage.setItem("unkey", timestamp);
            this.printNode = false
          }
        })
      },
      printNodeData(selectedOptions){
        const targetOption = selectedOptions[selectedOptions.length - 1];
        targetOption.loading = true;
        ajax.get(api.PRINTNODEPROFILENAME,{warehouse: selectedOptions[0].key}).then(res=>{
          let data = res.data
          this.printNodeNameArr = res.data
          targetOption.loading = false
          targetOption.children = data
          this.printNodeArr = [...this.printNodeArr];
        })
      },
      printNodeData11(){
        ajax.get(api.PRINTNODEWARHOUSE).then(res=>{
          this.printNodeArr = res.data
          for(let i in this.printNodeArr){
            this.printNodeArr[i].isLeaf = false
          }
        })
      },
      loginMarkLoadData(selectedOptions){
        const targetOption = selectedOptions[selectedOptions.length - 1];
        targetOption.loading = true;
        if(selectedOptions.length == 1){
          ajax.get(api.MARKUSERPROJECTCODE,{orgCode: selectedOptions[0].key}).then(res=>{
            targetOption.loading = false
            let data = res.data
            for(let i in data){
              if(selectedOptions.length  ==  1){
                data[i].isLeaf = false
              }
            }
            targetOption.children = data
            this.loginMarkArr = [...this.loginMarkArr];
          })
        }
        if(selectedOptions.length == 2){
          ajax.get(api.MARKUSERALLLOGINACCOUNT,{orgCode: selectedOptions[0].key, projectCode: selectedOptions[1].key}).then(res=>{
            let data = res.data
            targetOption.loading = false
            targetOption.children = data
            this.loginMarkArr = [...this.loginMarkArr];
          })
        }
      },
      logoutMark(){
        ajax.get(api.USERLOGOUTLOGINACCOUNT).then(res=>{
          if(res.code == 200){
            sessionStorage.removeItem("menu");
            sessionStorage.removeItem("menuActive");
            this.userlogin();
            this.$message.success(res.msg)
          }
        })
      },
      loginMark(){
        this.loginMarkVis = true
        ajax.get(api.USERORGCODE).then(res=>{
          this.loginMarkArr = res.data
          for(let i in this.loginMarkArr){
            this.loginMarkArr[i].isLeaf = false
          }
        })
      },
      loginMarkSubMint(){
        this.loginMarkValue[2]
        if(this.loginMarkValue[2] == undefined){
          this.$customMessage.warning(this.$t('publicLang.PleaseSelect'))
          return
        }
        ajax.get(api.UAERLOGINLOGINACCOUNT,{otherUserUid: this.loginMarkValue[2]}).then(res=>{
          if(res.code == 200){
            sessionStorage.removeItem("menu");
            sessionStorage.removeItem("menuActive");
            this.loginMarkVis = false
            this.userlogin();
//                        this.reload()
          }
        })
      },
      closeMenuTop(){
        sessionStorage.removeItem("menu");
        sessionStorage.removeItem("menuActive");
        this.leftMenuActive = '0'
        this.gteuserMenu()
      },
      cityChange(val){
        this.cityArr = val
      },
      cityLoadData(selectedOptions) {
        const targetOption = selectedOptions[selectedOptions.length - 1];
        targetOption.loading = true;
        let params = {
          lang:1
        }
        if(selectedOptions.length > 1){
          params.addressType = 2
          params.address= selectedOptions[1].ebplCode
        }else{
          params.addressType = 1
          params.address= selectedOptions[0].ebplCode
        }
        ajax.post(api.GETUSERADDRESS,params).then(res=>{
          targetOption.loading = false;
          let data = res.data
          for(let i in data){
            if(selectedOptions.length  ==  1){
              data[i].isLeaf = false
            }
          }
          targetOption.children = data
          this.cityOptions = [...this.cityOptions];
        })
      },
      loadingPub() {
        this.spinning = false;
      },
      applyLanguage(defaultLang) {
        const lang = String(defaultLang == null ? "2" : defaultLang)
        const locales = {
          "0": "zh",
          "1": "zh_tw",
          "2": "en",
          "3": "kor",
          "4": "th",
          "5": "jp"
        }
        this.$store.commit("updataLang", { lang })
        this.$i18n.locale = locales[lang] || "en"
      },
      userlogin() {
        ajax.get(api.USERLOGIN).then(res => {
          if (res.data == null) {
            return
          }
          res.data = JSON.parse(res.data);
          this.userInfo = res.data
          this.applyLanguage(res.data.defaultLang)
          if (res.data.firstLogin == "Y" && !String(res.data.domain || "").trim()) {
            this.validateLoginVisble = false
            this.FirstResetPassWordVis = true
            return
          }

          if (!res.data.status) {
            this.initializeValidateLoginForm(res.data)
            this.validateLoginVisble = true;
            return
          }

          if (res.code == 200 && res.data.passwordExpiring) {
            this.passwordExpiryDays = res.data.passwordExpiryDays;
            this.passwordExpiryVisible = true;
          }
          this.$store.commit("updataLang", { lang: res.data.defaultLang });
          this.gteuserMenu();
        });
      },
      initializeValidateLoginForm(data){
        this.validateDataEdit = data.email || ""
        this.cityArr = Array.isArray(data.city) ? data.city.filter(item => item) : []
        this.validateLoginDataAjax(this.cityArr)
        this.$nextTick(() => {
          this.validateLogin.setFieldsValue({
            firstName: data.firstName || "",
            lastName: data.lastName || "",
            dispName: data.dispName || "",
            middleName: data.middleName || "",
            email: data.email || "",
            departName: data.departName || "",
            position: data.position || "",
            telNum: data.telNum || "",
            timeZone: data.timeZone || undefined,
            defaultLang: data.defaultLang == null ? "2" : String(data.defaultLang),
            username: data.username || data.userName || ""
          })
        })
      },
      closePasswordExpiryModal() {
        this.passwordExpiryVisible = false;
      },
      validateLoginDataAjax(selectedCity = []){
        ajax.get(api.TIMEZONE).then(res => {
          this.loadingPub();
          this.timeZoneSelect = res.data;
        });
        let params = {
          addressType:0,
          address:"",
          lang:1
        }
        ajax.post(api.GETUSERADDRESS,params).then(res=>{
          const countries = res.data || []
          for(let i in countries){
            countries[i].isLeaf = false
          }
          this.cityOptions = countries

          if(selectedCity.length < 2){
            return
          }
          const country = countries.find(item => item.ebplCode == selectedCity[0])
          if(!country){
            return
          }
          return ajax.post(api.GETUSERADDRESS,{
            addressType:1,
            address:selectedCity[0],
            lang:1
          }).then(provinceRes=>{
            const provinces = provinceRes.data || []
            for(let i in provinces){
              provinces[i].isLeaf = false
            }
            country.children = provinces
            this.cityOptions = [...countries]

            if(selectedCity.length < 3){
              return
            }
            const province = provinces.find(item => item.ebplCode == selectedCity[1])
            if(!province){
              return
            }
            return ajax.post(api.GETUSERADDRESS,{
              addressType:2,
              address:selectedCity[1],
              lang:1
            }).then(cityRes=>{
              province.children = cityRes.data || []
              this.cityOptions = [...countries]
            })
          })
        })
      },

      //      project 保存 刷新当前数据
      projectModel() {
        this.projectVisble = true;
      },
      projectSelectChange(val){
        let data = this.userInfo.projectCodeList
        for(let i in data){
          if(data[i].projectCode == val){
            this.projectWarehouseCode = data[i].warehouseCode
            this.projectPageSize = data[i].pageSize
          }
        }
      },
      projectFilterOption(input, option) {
        const searchValue = (input || "").toLowerCase();
        const propsData = option && option.componentOptions ? option.componentOptions.propsData || {} : {};
        const projectCode = (propsData.value || "").toString().toLowerCase();
        const displayName = (propsData.label || "").toString().toLowerCase();
        const optionText = option && option.componentOptions && option.componentOptions.children && option.componentOptions.children[0]
                ? (option.componentOptions.children[0].text || "").toString().toLowerCase()
                : "";
        return projectCode.indexOf(searchValue) >= 0
                || displayName.indexOf(searchValue) >= 0
                || optionText.indexOf(searchValue) >= 0;
      },
      projectChange() {
        this.projectForm.validateFields((err, values) => {
          if (!err) {
            sessionStorage.setItem("pageSize", this.projectPageSize)
            ajax.post(api.USERPROJECTCODE, { projectCode: values.selectProjectModelcheck,warehouseCode: values.projectWarehouseCode })
                    .then(res => {
                      if(res.code == 200){
                        this.projectVisble = false
                        this.closeMenuTop()
                        this.reload()

                        let token = res.data.token;
                        if (typeof token === 'string' && token.startsWith("Bearer ")) {
                          token = token.replace("Bearer ", "");
                        }
                        sessionStorage.setItem("token",token)

                      }else{
                        this.$customMessage.error(res.msg);
                        return
                      }
                    });
          }
        });
      },
      validateSubnit() {
        this.validateLogin.validateFields((err, value) => {
          if(!err){
            let params = value;
            params.city =  this.cityArr
            ajax.post(api.USER, params).then(res => {
              if (res.code == 200) {
                this.$store.commit("updataLang", { lang: res.data.lang });
                this.validateLoginVisble = false;

                this.gteuserMenu();
              }else{
                this.$customMessage.error(res.msg);
                return
              }
            });
          }
        });
      },
      //      中英文切换
      changeLang(item) {
        this.LanguageText = item.val;
        if(item.lang == 0){
            this.$i18n.locale = 'zh';
        }else if(item.lang == 1){
            this.$i18n.locale = 'zh_tw';
        }else{
            this.$i18n.locale = 'en';
        }

        ajax.get(api.CHANGELANG,{ lang: item.lang}).then(res=>{
          if (res.code == 200) {
            let token = res.data.token;
            if (typeof token === 'string' && token.startsWith("Bearer ")) {
              token = token.replace("Bearer ", "");
            }
            sessionStorage.setItem("token", token);
            this.$store.commit("updataLang", { lang: item.lang });
            this.gteuserMenu();
          }else{
            this.$customMessage.error(res.msg);
            return
          }
        })
      },
      // 跳转页面先这样写着
      onEdit(targetKey, action) {
        this[action](targetKey);
      },
      printNodeMenuItem(){
        this.printNode = true
      },
      //      删除导顶部
      remove(targetKey) {
        let activeKey = this.activeKey;
        let lastIndex;
        this.panes.forEach((pane, i) => {
          if (pane.key === targetKey) {
            lastIndex = i - 1;
          }
        });
        if (lastIndex == -1) {
          lastIndex = 0;
        }

        const panes = this.panes.filter(pane => pane.key !== targetKey);
        if (lastIndex >= 0 && activeKey === targetKey) {
          if (panes.length > 0) {
            activeKey = panes[lastIndex].key;
          } else {
            activeKey = "";
          }
        }
        this.panes = panes;
        this.activeKey = activeKey;


        this.panes.forEach(v => {
          if (v.key == this.activeKey) {
            let item = v
            this.fuctionRouterCode(item)
          }
        });
        sessionStorage.setItem("menu", JSON.stringify(this.panes));
        sessionStorage.setItem("menuActive", activeKey);
        if (JSON.parse(sessionStorage.getItem("menu")).length < 1) {
          let item = this.userMenu[0]
          this.fuctionRouterCode(item)
        }
      },
      updatePanes(item) {
        let isExist = false;
        for (let i  in this.panes){
          let menu = this.panes[i];
          if (menu.funcCode == item.funcCode){
            isExist = true;
            if (item.importUids != undefined && item.importUids != null ){
              menu.importUids = item.importUids;
            }
            break;
          }
        }
        if (! isExist){
          this.panes.push(item);
        }

        this.activeKey = item.key;
        this.leftMenuActive = item.key;
        sessionStorage.setItem("menu", JSON.stringify(this.panes));
        sessionStorage.setItem("menuActive", item.key);

        this.$router.push({
          path: item.url,
          query: {
            funApi: item.funApi,
            userUid: item.userUid,
            funcUid: item.functionUid
          }
        })

        if (item.funcCode == 'M_OUTB_WAVE'){
          this.$nextTick(()=>{
            this.$refs.viewFun.init("empty_temp");
          })
        }
      },
      //      获取住导航
      gteuserMenu() {
        let pageConfig = JSON.parse(sessionStorage.getItem("pageConfig"))
        if(pageConfig){
          this.seetingPage.typeBuju = pageConfig.typeBuju
          this.seetingPage.pageZoom = pageConfig.pageZoom
          this.pageZoomChange()
        }
        if (this.lang == "0") {
            this.LanguageText = "简体中文";
			this.$i18n.locale = 'zh';
        } else if (this.lang == "1") {
            this.LanguageText = "繁体中文";
			this.$i18n.locale = 'zh_tw';
        } else if (this.lang == "2") {
            this.LanguageText = "English";
			this.$i18n.locale = 'en';
        }else if (this.lang == "3") {
          this.LanguageText = "한글";
          this.$i18n.locale = 'kor';
        }else if (this.lang == "4") {
          this.LanguageText = "ภาษาไทย";
          this.$i18n.locale = 'th';
        }else if (this.lang == "5") {
          this.LanguageText = "日本語";
          this.$i18n.locale = 'jp';
        }
        if (sessionStorage.getItem("menu") != null) {
          this.panes = JSON.parse(sessionStorage.getItem("menu"));
          this.activeKey = sessionStorage.getItem("menuActive");
        } else {
          this.panes = [];
          this.activeKey = "";
        }
        let params = {
          lang: this.lang
        };
        ajax.get(api.GETUSERMENU, params).then(res => {
          this.loadingPub();
          if (res.code == 200) {
            this.userMenu = res.data.list;
            this.userInfo = res.data;
            this.projectPageSize = res.data.pageSize;
            sessionStorage.setItem("pageSize", this.projectPageSize)

            this.systemVersion = res.data.systemVersion;
            this.$store.commit("updataRole", { Role: this.userInfo.role });
            this.$store.commit("updataWhsCode", { whsCode: res.data.warehouseCode });
			      this.$store.commit("updateProjectCode", JSON.parse(JSON.stringify(res.data.projectCode)));
            // this.$store.commit("updataScanpackWay", { scanpackWay: res.data.scanpackWay });
            // this.$store.commit("updateTodsScanSkuLength", { todsScanSkuLength: res.data.todsScanSkuLength});
            // this.$store.commit("updateCainiaoJdAutoPrint", { CAINIAO_JD_AUTO_PRINT: res.data.CAINIAO_JD_AUTO_PRINT});
            // this.$store.commit("systemVersion", {systemVersion: res.data.systemVersion });
//                         this.$store.commit("updataScanpackWay", { scanpackWay: 'Y' });
           this.$store.commit("updataGrCombine", { isGrCombine: res.data.isGrCombine });
            sessionStorage.setItem("environment", this.userInfo.environment);

						 // 获取系统参数
                         ajax.get(api.SYSTEMPARAM).then(res => {
                              let systemParam =   res.data;
                                this.$store.commit("updateSystemParam",systemParam );
                         })

			// 保存用户菜单 Tom 20240116
            sessionStorage.setItem("userMenuJson", JSON.stringify(this.userMenu));




            let unkey = localStorage.getItem("unkey")

            if(unkey != null){
              ajax.get(api.PRINTNODEPOP,{uniqueName: unkey}).then(res=>{
                if(res.data.isPrintProfilePopup){
                  this.printNode = true
                }
              })
            }else{
              if(this.userInfo.isPrintProfilePopup){
                this.printNode = true
              }
            }

     
            this.projectModelcheck = this.userInfo.displayName;
            this.selectProjectModelcheck = this.userInfo.projectCode
            this.projectWarehouseCode = this.userInfo.warehouseCode
            if(this.selectProjectModelcheck == null ||  this.projectWarehouseCode == null){
              this.projectVisble = true
            }
            let copyObj = null;
            if(this.userMenu.length == 0){
              this.panes = []
              return
            }
            for (let ii in this.userMenu) {
              this.rootSubmenuKeys.push(this.userMenu[ii].key)
              if (this.userMenu[ii].funcCode == "M_INV") {   //  深复制
                let childrens = this.userMenu[ii].children;
                if(childrens != null && childrens.length > 0){
                  for(let item of  childrens){
                    if (item.funcCode == 'M_INV_ENQ'){
                      copyObj = this.deepClone(item);
                    }
                  }
                }
                break;
              }
            }





            let  firstPage = '/enquiryLot'   // 首页默认页面
            if(copyObj == null){      // 构建首页对象
              copyObj = new Object();
              copyObj.children = [];
              copyObj.closable = false;
              copyObj.depth = null;
              copyObj.funApi ='/generic/impl?menu=INV_ENQ';
              copyObj.functionUid = 129;
              copyObj.icon = null;
              copyObj.parentName = "Inventory";
              copyObj.url = "/sku";
              copyObj.userUid = "DF4EAC7C-AD36-4EFA-99F5-72696BDDB9AA"
              copyObj.funcCode = "blankHome";
              firstPage = '/blankHome';   // 修改首页页面为空白页
            }else{
              copyObj.funcCode  = 'Home';   // 修改首页页面为空白页
            }
            this.userMenu.unshift(copyObj);        // 首页放置菜单第一位
            this.userMenu[0].funcName = this.$i18n.t('generic.Home');
            this.userMenu[0].key = "0";            // 默认Index
            this.userMenu[0].closable = false;     // 设置 菜单下导航栏不显示 关闭 按钮


            let kebo = sessionStorage.getItem("menuActive");
            if (kebo == null) {
              if(copyObj != null || this.userMenu.length == 0){
                this.panes.push(this.userMenu[0]);
                sessionStorage.setItem("menu", JSON.stringify(this.panes));
                sessionStorage.setItem("menuActive", this.userMenu[0].key);
                this.activeKey = '0'
                this.$router.push({
                  path: firstPage,
                  query: {
                    funApi: this.userMenu[0].funApi,
                    userUid: this.userMenu[0].userUid,
                    funcUid: this.userMenu[0].functionUid
                  }
                });
              }else{
                let index = this.userMenu[0].children[0];
                this.panes.push(index);
                sessionStorage.setItem("menu", JSON.stringify(this.panes));
                sessionStorage.setItem("menuActive", index.key);
                this.activeKey = index.key;
                this.fuctionRouterCode(index)
              }
            } else {
              this.panes = JSON.parse(sessionStorage.getItem("menu"))
              this.leftMenuActive = sessionStorage.getItem("menuActive")
              for (let ii in this.panes) {
                if (this.panes[ii].key == this.leftMenuActive) {
                  let item = this.panes[ii]
                  this.fuctionRouterCode(item)
                }
              }
            }
          }

        });
      },
      deepClone(obj) {
        if(obj == null || obj == undefined){
          return null;
        }
        let _obj = JSON.stringify(obj),
                objClone = JSON.parse(_obj);
        return objClone;
      },
      //      menu跳转
      routersPubFn(url,item,tms=false){
//                添加top menu 去重
        this.panes.push(item);
        this.activeKey = item.key;
        this.panes = this.panes.reduce((total, current) => {
          const exist = total.some(t => t.key === current.key);
          if (!exist) {
            total.push(current);
          }
          return total;
        }, []);

        this.leftMenuActive = item.key
        sessionStorage.setItem("menu", JSON.stringify(this.panes));
        sessionStorage.setItem("menuActive", item.key);

        this.$router.push({
          path: url,
          query: {
            funApi: item.funApi,
            userUid: item.userUid,
            funcUid: item.functionUid
          }
        })
      },
      selectMenuApi(item){//首页顶部二级菜单点击事件
        if (item.children.length > 0){
          return
        }else{
          if(item.url == "/lpn"){
            this.$refs.lpnPrintRef.show()
            return
          }else if (item.url == "/qr_code"){
            this.$refs.qrCodeRef.show()
             return
	        }else if (item.url == "/reprot_convert"){
	          this.$refs.convertCountResultRef.show()
	          return
          }else if (item.url == "/printPriceLabel"){
            this.$refs.printPriceLabel.show()
            return
          }else if (item.url == "/scanToPrint"){
            this.$refs.scanToPrintWindow.show()
            return
          }
          this.fuctionRouterCode(item)
          // this.$nextTick(()=>{
          //   console.log(this.$refs.viewFun);
          //     this.$refs.viewFun.cleardata()
          // })
        }
      },
      TopTabClick(t){
        this.leftMenuActive = t
        sessionStorage.setItem("menuActive", t);
        for (let ii in this.panes) {
          if (this.panes[ii].key == t) {
            let item = this.panes[ii]
            this.fuctionRouterCode(item)
          }
        }
      },
      fuctionRouterCode(item){
        if(item.funcCode == "blankHome"){
          this.routersPubFn('/blankHome',item)
        }else if(item.funcCode == "M_OUTB_SHIP_ORDER"){
          this.routersPubFn('/shipmentOrder',item)
        } else if(item.funcCode== "M_NON_EDIT"){
          this.routersPubFn('/noneEditable',item)
        }else if(item.funcCode== "M_GE_EXT_HEADER"){
          this.routersPubFn('/proj_ge',item)
        } else if(item.funcCode == "M_TMS_DO_HEADER"){
          this.routersPubFn('/tmsOrder',item, true)
          //   传给不同表格参数
          for(let i in this.userMenu){
            if(this.userMenu[i].funcCode == "M_TMS"){
              for(let t in this.userMenu[i].children){
                if(this.userMenu[i].children[t].funcCode == "M_TMS_ROUTE_HEADER"){
                  this.$store.commit("updataUseCase1", { useCase1: this.userMenu[i].children[t] });
                }
              }
            }
          }
          this.$store.commit("updataUseCase4", { useCase4: item });
        }else if(item.funcCode == "M_T_DRIVER"){
          this.routersPubFn('/driver',item)
        }else if(item.funcCode == "M_TMS_VEHICLE"){
          this.routersPubFn('/vehicle',item)
        }else if(item.funcCode == "M_INB_ASN_STATIC"){
          this.routersPubFn('/asnStatic',item)
        }else if(item.funcCode == "M_USER_GENERIC"){
          this.routersPubFn('/userGeneric',item)
        }else if(item.funcCode == "M_SCAN_IN"){
          this.$refs.scanInRefs.showIn()
        } else if(item.funcCode == "M_SCAN_PACK") {
          this.$refs.scanpackRefs.show()
        }else if(item.funcCode == "M_SCAN_PACK_PICKTOZERO") {
          this.$refs.scanPackPickToZero.show()
        }else if(item.funcCode == "M_V_GE_MAP_MASTER"){
          this.routersPubFn('/importConfig',item)
        }else if(item.funcCode == "M_USER_REPORT") {
          this.routersPubFn('/userReport', item)
        }else if(item.funcCode == "M_MS_WHS"){
          this.routersPubFn('/whs',item)
        } else if (item.funcCode == "M_MS_LOC"){
          this.routersPubFn('/loa',item)
        } else if(item.funcCode == "M_MS_ORG"){
          this.routersPubFn('/ogr',item)
        } else if(item.funcCode == "M_MS_PROJ"){
          this.routersPubFn('/project',item)
        } else if(item.funcCode == "M_MS_PTNR"){
          this.routersPubFn('/partner',item)
        } else if(item.funcCode == "M_MS_SKU"){
          this.routersPubFn('/skuHeader',item)
        } else if(item.funcCode == "M_GENE_MA"){
          this.routersPubFn('/generic',item)
        } else if(item.funcCode == "M_SYS_PARAM"){
          this.routersPubFn('/sysparam',item)
        } else if(item.funcCode == "M_SYS_MULT"){
          this.routersPubFn('/mult',item)
        } else if(item.funcCode == "M_SYS_CO_MA"){
          this.routersPubFn('/codeMaster',item)
        } else if(item.funcCode == 'M_SYS_USER'){
          this.routersPubFn('/user',item)
        } else if(item.funcCode == "M_SYS_ROLE"){
          this.routersPubFn('/role',item)
        } else if(item.funcCode == "M_MENU"){
          this.routersPubFn('/menu',item)
        } else if(item.funcCode == "M_FIELD_MAP"){
          this.routersPubFn('/mapTo',item)
        } else if(item.funcCode == "M_MODULE"){
          this.routersPubFn('/sysModule',item)
        } else if(item.funcCode == "M_ID_GEN"){
          this.routersPubFn('/idGener',item)
        } else if(item.funcCode == "ALL_RULE"){
          this.routersPubFn('/all_rule',item)
        } else if(item.funcCode == "M_INV_CODE"){
          this.routersPubFn('/invCode',item)
        } else if(item.funcCode == "M_EXT_USER"){
          this.routersPubFn('/rfUser',item)
        } else if(item.funcCode == "M_INB_PO"){
          this.routersPubFn('/po',item)
        } else if(item.funcCode == "M_INB_ASN"){
          this.routersPubFn('/asn',item)
        } else if(item.funcCode == "M_INB_GR"){
          this.routersPubFn('/inbGr',item)
        } else if(item.funcCode == "M_INB_REC"){
          this.routersPubFn('/receive',item)
        } else if(item.funcCode == "M_PUTAWAY"){
          this.routersPubFn('/putaway',item)
        } else if(item.funcCode == "M_OUTB_PSO"){
          this.routersPubFn('/pso',item)
        } else if(item.funcCode == "M_OUTB_SO"){
          this.routersPubFn('/so',item)
        } else if(item.funcCode == "M_OUTB_WAVE"){
          this.routersPubFn('/wave',item)
        } else if(item.funcCode == "M_OUTB_PICK"){
          this.routersPubFn('/pick',item)
        } else if(item.funcCode == "M_EDI_LOG_SUMMARY"){
          this.routersPubFn('/ediLogSummary',item)
        } else if(item.funcCode == "M_OUTB_PACK"){
          this.routersPubFn('/pack',item)
        } else if(item.funcCode == "M_LOAD"){
          this.routersPubFn('/cmg',item)
        } else if(item.funcCode == "M_INV_BAL"){
          this.routersPubFn('/balance',item)
        } else if(item.funcCode == "M_INV_TRAN"){
          this.routersPubFn('/transaction',item)
        } else if(item.funcCode == "M_INV_TRAN_NEW"){
          this.routersPubFn('/transactionNew',item)
        } else if(item.funcCode == "M_INV_ENQ" || item.funcCode == "Home"){
          this.routersPubFn('/enquiryLot',item)
        } else if(item.funcCode == "M_INV_ENQ_USER"){
          this.routersPubFn('/enquiryUser',item)
        } else if(item.funcCode == "M_INV_ENQ_SKU"){
          this.routersPubFn('/enquirySku',item)
        } else if(item.funcCode == "M_INV_ENQ_LOC"){
          this.routersPubFn('/enquiryLoc',item)
        } else if(item.funcCode == "M_MOVE"){
          this.routersPubFn('/lnvnMove',item)
        } else if(item.funcCode == "M_ADJUSTMENT"){
          this.routersPubFn('/invAdjust',item)
        } else if(item.funcCode == "M_TRANSFER"){
          this.routersPubFn('/invTransfer',item)
        } else if(item.funcCode == "M_T_INV_HOLD"){
          this.routersPubFn('/invHold',item)
        } else if(item.funcCode == "M_MS_JOB"){
          this.routersPubFn('/job',item)
        } else if(item.funcCode == "M_SUPPORT"){
          this.routersPubFn('/support',item)
        } else if(item.funcCode == "M_BILLING_MAINTANCE"){
          this.routersPubFn('/billingMaintance',item)
        }else if(item.funcCode == "M_MS_TIMER"){
          this.routersPubFn('/timer',item)
        }else if(item.funcCode == "M_DO Maintenance"){
          this.routersPubFn('/doOrders',item)
        }else if(item.funcCode == "M_STD_BALANCE_REPORT"){
          this.routersPubFn('/stdBalanceReport',item)
        }else if(item.funcCode == "M_DELIVERY_ORDER"){
          this.routersPubFn('/deliveryOrderSum',item)
        }else if(item.funcCode == "M_CFS_ORDER") {
          this.routersPubFn('/consignment',item)
        }else if(item.funcCode == "M_CFS_PALLET") {
          this.routersPubFn('/pallet',item)
        }else if(item.funcCode == "M_CFS_SHIPMENT" || item.funcCode == "CFS_SHIPMENT") {
          this.routersPubFn('/shipment',item)
        }else if(item.funcCode == "CFS_CONSOLIDATION") {
          this.$refs.consolidationRefs.show()
        }else if(item.funcCode == "CFS_SCAN_IN") {
          this.$refs.cfsScanInRefs.show()
        }else if(item.funcCode == "CFS_SCAN_PACK") {
          this.$refs.cfsScanPackRefs.show()
        }else if(item.funcCode == "CFS_SCAN_LOAD") {
          this.$refs.cfsScanLoadRefs.show()
        }else if(item.funcCode == "M_CYCLE_COUNT") {
          this.routersPubFn('/cycleCount', item)
        } else if(item.funcCode == "M_CYCLE_COUNT_MASTER") {
                  this.routersPubFn('/cycleCountMaster', item)
        } else if(item.funcCode == "M_SPLIT_SCAN") {
              this.$refs.splitScanRef.show()
        } else if (item.funcCode == "M_PRINT_PRICE_TAG") {
          this.routersPubFn('/printPriceTag', item)
        }else if(item.funcCode == "M_NON_WORKDAY_MASTER") {
          this.routersPubFn('/nonWorkdayMaster', item)
        }else if(item.funcCode == "M_APPROVAL_PATH_MASTER") {
          this.routersPubFn('/approvalPathMaster', item)
        }
        else{
          this.routersPubFn('/sku',item)
        }
        if(item.key == 0){
          return
        }
      },
            releaseNotes() {
              if (this.systemVersion) {
                ajax.get(api.RELEASENOTES, {systemVersion: this.systemVersion}).then(res => {
                  if (res.code == 200) {
                  this.downloadReleaseNotes();
                } else {
                  this.$message.warning(res.msg);
                }
              })
            }
          },

          downloadReleaseNotes() {
            let fileName = this.systemVersion + '.txt';
            let params = {
              systemVersion: this.systemVersion
            }
            //store.commit("updataLoading", { pbLoading: true });
            axios.get(ajax.ajaxUrl() + api.DOWNLOADRELEASENOTES, {
              params,
              headers: {
                Authorization: cookie.getBearerToken()
              },
              responseType: "blob"
            }).then(res => {
              //store.commit("updataLoading", {pbLoading: false});
              var blob = new Blob([res.data], {type: "application/octet-stream;charset=UTF-8"});
              var url = window.URL.createObjectURL(blob);
              var aLink = document.createElement("a");
              aLink.style.display = "none";
              aLink.href = url;
              aLink.setAttribute("download", fileName);
              document.body.appendChild(aLink);
              aLink.click();
              document.body.removeChild(aLink);
              window.URL.revokeObjectURL(url);
            }).catch(function (error) {
              //store.commit("updataLoading", {pbLoading: false});
              alert(error);
            });
          },

      //      退出
      outLogin(){
        if(this.userInfo.logoutMark){
          ajax.get(api.USERLOGOUTLOGINACCOUNT).then(res=>{
            sessionManager.clearUserData();
            this.$router.push({path: "/login"})
            this.leftMenuActive = '0'
          })
        }else{
          sessionManager.clearUserData();
          this.$router.push({path: "/login"})
          this.leftMenuActive = '0'
        }
      },
      login() {
        sessionStorage.removeItem("menu");
        sessionStorage.removeItem("menuActive");
        let that = this;
        let applicationConfig = {
          clientID: "5823ab48-6ab6-4f34-aef7-324473de00b3",
          authority:
                  "https://login.microsoftonline.com/tfp/ecwmsb2c.onmicrosoft.com/B2C_1_signup_signin",
          b2cScopes: ["https://ecwmsb2c.onmicrosoft.com/client-app/user.read"],
          webApi: "https://fabrikamb2chello.azurewebsites.net/hello"
        };
        applicationConfig.clientID_array = [];
        applicationConfig.clientID_array.push(applicationConfig.clientID);
        let UserAgentApplication = new Msal.UserAgentApplication(
                applicationConfig.clientID,
                applicationConfig.authority
        )
        UserAgentApplication.loginRedirect(applicationConfig.b2cScopes);

//          clientApplication.loginPopup(applicationConfig.b2cScopes)
//        .then(function(idToken) {
//          clientApplication
//            .acquireTokenSilent(applicationConfig.clientID_array)
//            .then(
//              function(accessToken) {
//                cookie.set("token", accessToken, 1);
//                that.$router.push({ path: "/page" });
//              },
//              function(error) {
//                clientApplication
//                  .acquireTokenPopup(applicationConfig.b2cScopes)
//                  .then(function(accessToken) {
//                    cookie.set("token", accessToken, 1);
//                    that.$router.push({ path: "/page" });
//                  });
//              }
//            );
//        });
      },
//      获取浏览器详情
      getliulanInfo(){
        this.browser = {}
        this.browser.browserVersion = this.getExplorerVersion()
        this.browser.getOs = this.GetOs()
        var start = new Date().getTime();
        ajax.get(api.GETUSERMENU, {lang: this.lang}).then(res=>{
          this.onLoad(start)
          ajax.post(api.GENERICMON,this.browser).then(res=>{
            this.$message.success('Thank you for your cooperation, issue was submitted to IT for further investigating.')
          })
        })

      },
      onLoad(start) {
        var now = new Date().getTime();
        var latency = now - start;
        this.browser.time = latency
      },
      getExplorerVersion() {

        var Sys = {};

        var ua = navigator.userAgent.toLowerCase();

        var s;

        var result = "";

        (s = ua.match(/qqbrowser\/([\d.]+)/)) ? Sys.qqbrowser = s[1]:

                (s = ua.match(/msie ([\d.]+)/)) ? Sys.ie = s[1] :

                        (s = ua.match(/(trident)\/([\d.]+)/)) ? Sys.ie = '11.0' :

                                (s = ua.match(/firefox\/([\d.]+)/)) ? Sys.firefox = s[1] :

                                        (s = ua.match(/chrome\/([\d.]+)/)) ? Sys.chrome = s[1] :

                                                (s = ua.match(/opera.([\d.]+)/)) ? Sys.opera = s[1] :

                                                        (s = ua.match(/version\/([\d.]+).*safari/)) ? Sys.safari = s[1] : 0;

        if(Sys.ie)

          result = "IE " + Sys.ie;

        else if(Sys.firefox)

          result = "firefox " + Sys.firefox;

        else if(Sys.chrome)

          result = "chrome " + Sys.chrome;

        else if(Sys.opera)

          result = "opera " + Sys.opera;

        else if(Sys.safari)

          result = "safari" + Sys.safari;

        else if(Sys.qqbrowser)

          result = "QQBrowser" + Sys.qqbrowser;

        else

          result = "未知";

        return result

      },
      GetOs () {
        var sUserAgent = navigator.userAgent;
        var isWin = (navigator.platform == "Win32") || (navigator.platform == "Windows");
        var isMac = (navigator.platform == "Mac68K") || (navigator.platform == "MacPPC") || (navigator.platform == "Macintosh") || (navigator.platform == "MacIntel");
        if (isMac) return "Mac";
        var isUnix = (navigator.platform == "X11") && !isWin && !isMac;
        if (isUnix) return "Unix";
        var isLinux = (String(navigator.platform).indexOf("Linux") > -1);
        if (isLinux) return "Linux";
        if (isWin) {
          var isWin2K = sUserAgent.indexOf("Windows NT 5.0") > -1 || sUserAgent.indexOf("Windows 2000") > -1;
          if (isWin2K) return "Win2000";
          var isWinXP = sUserAgent.indexOf("Windows NT 5.1") > -1 || sUserAgent.indexOf("Windows XP") > -1;
          if (isWinXP) return "WinXP";
          var isWin2003 = sUserAgent.indexOf("Windows NT 5.2") > -1 || sUserAgent.indexOf("Windows 2003") > -1;
          if (isWin2003) return "Win2003";
          var isWinVista= sUserAgent.indexOf("Windows NT 6.0") > -1 || sUserAgent.indexOf("Windows Vista") > -1;
          if (isWinVista) return "WinVista";
          var isWin7 = sUserAgent.indexOf("Windows NT 6.1") > -1 || sUserAgent.indexOf("Windows 7") > -1;
          if (isWin7) return "Win7";
          var isWin10 = sUserAgent.indexOf("Windows NT 10") > -1 || sUserAgent.indexOf("Windows 10") > -1;
          if (isWin10) return "Win10";
        }
        return "other";
      }
    }
  };
</script>
<style lang="less">
  .statusbtn {
    color: #d6caca;
    cursor: not-allowed; /*这个在button上面才管用,是一个禁用的小标识*/
  }

  /*ant-menu ant-menu-vertical ant-menu-sub ant-menu-submenu-content*/
  /*ant-menu ant-menu-horizontal ant-menu-root ant-menu-dark*/

  /*.ant-menu-submenu-content>.ant-menu-submenu-title>.topMenuLiClass{*/
  /*border: none !important*/
  /*}*/
  /*.ant-menu-submenu-content>.ant-menu-submenu-title>.topMenuLiClass>.menuImgClass{*/
  /*display: none !important;*/
  /*}*/
  /*.ant-menu>.ant-menu-submenu-active>.ant-menu-submenu>.ant-menu-submenu-title>.topMenuLiClass{*/
  /*border: none !important;*/
  /*}*/
  /*.ant-menu>.ant-menu-submenu-active>.ant-menu-submenu>.ant-menu-submenu-title>.topMenuLiClass>img.menuImgClass{*/
  /*display: none !important;*/
  /*}*/
  .ant-menu-submenu>.ant-menu-submenu-title>.topMenuLiClass>.menuImgClass{
    display: none;
  }
  .ant-menu-submenu>.ant-menu-submenu-title>.topMenuLiClass>.menuTitleClass{
    line-height: 10px;
    font-size: 12px;
  }
  .topMenuNoBorder{
    border-left: none;
  }
  .ant-menu-dark>.ant-menu-submenu>.ant-menu-submenu-title>.topMenuLiClass{
    width: 100px;
    border-left: 1px solid #fff;
    text-align: center;
  }
  .ant-menu-dark>.ant-menu-submenu>.ant-menu-submenu-title>.topMenuLiClass>.menuTitleClass{
    line-height: 10px;
    margin-top: 18px;
    font-size: 12px;
  }
  .ant-menu-dark>.ant-menu-submenu>.ant-menu-submenu-title>.topMenuLiClass>.menuImgClass {
    display: block;
    width: 20px;
    height: 20px;
    margin: 0 auto;
  }

  .ant-menu-submenu-content > .ant-menu-item > .ant-row >img{
    display: none;
  }
  /*布局1的样式*/
  #topMenuBuju2>ul>li:hover{
    background: #4ea8d4;
    color: #fff;
  }


  .ant-menu-dark .ant-menu-submenu-selected{
    background: #5fafd6;
    color: #fff;
  }
  .logoClass{
    font-size: 20px;
    font-family: auto;
    color: #fff
  }



  .seetingbujiChek{
    position: absolute;
    bottom: 3px;
    right: 3px;
    color: #1890ff
  }
  .TitleInfoheader{
    background:#fff;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #efefef
  }
  #components-layout-demo-custom-trigger .logo img{
    width: 42px !important;
    height: 40px !important;
  }
  .infoSelectClass {
    font-size: 12px;
    cursor: pointer;
    padding: 5px 0;
  }
  .infoSelectClass:hover {
    color: #1890ff;
  }
  #components-layout-demo-custom-trigger {
    .logo {
      height: 50px;
      line-height: 64px;
      margin-left: 16px;
      overflow: hidden;
      img {
        width: 42px;
        height: 32px;
        vertical-align: middle;
      }
      h1 {
        display: inline-block;
        margin: 0 0 0 12px;
        color: #fff;
        font-weight: 800;
        vertical-align: middle;
        font-family: Mv Boli;
      }
    }
    .header-right {
      margin-right: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      .userInfo {
        display: block;
        justify-content: center;
        align-items: center;
        margin-right: 20px;
        img {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          margin-right: 8px;
        }
      }
    }
  }
  /*!*框架样式*! menu*/
  .ant-tabs-nav-container-scrolling{
    padding: 0 15px;
  }
  .ant-tabs-tab-prev.ant-tabs-tab-arrow-show, .ant-tabs-tab-next.ant-tabs-tab-arrow-show{
    width:10px;
  }
  .ant-pagination-options-size-changer.ant-select {
    float: right;
  }
  .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {
    line-height: 22px !important;
    height: 25px;
    border-radius: 20px;
    background: #c6c6c6 !important;
    color: #333 !important;
  }
  .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
    background: #2B9ED6 !important;
    color: #fff !important;
    font-size:12px;
  }
  .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab .ant-tabs-close-x {
    color: #333 !important;
  }
  .ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title,
  .ant-menu-sub.ant-menu-inline > .ant-menu-item {
    height: 30px !important;
    line-height: 30px !important;
    font-size: 13px;
  }
  .ant-menu.ant-menu-dark .ant-menu-item-selected,
  .ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected {
    background: #5fafd6 !important;
  }
  .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-nav-container {
    height: 30px !important;
  }
  .ant-menu-dark,.ant-menu-dark .ant-menu-sub {
    background: #2B9ED6 !important;
  }
  .ant-layout-sider {
    background: #2B9ED6 !important;
  }
  #components-layout-demo-custom-trigger .trigger {
    font-size: 18px;
    line-height: 64px;
    padding: 0 24px;
    cursor: pointer;
    transition: color 0.3s;
  }
  .ant-menu-submenu-arrow:before,
  .ant-menu-submenu-arrow:after {
    background: #fff !important;
  }
  /*#components-layout-demo-custom-trigger .trigger:hover {*/
  /*color: #c9c01b !important;*/
  /*}*/

  .ant-tabs .ant-tabs-bar {
    margin: 0;
    padding-top: 1px;
    /*border-bottom: none !important;*/
  }
  .ant-table-tbody {
    tr:nth-of-type(odd) {
      background: #fff;
    }
    tr:nth-of-type(even) {
      background: #e7eef8;
    }
  }
  .ant-table-thead > tr > th {
    background: #fafafa !important;
  }
  .ant-table-pagination.ant-pagination {
    margin-bottom: 0px !important;
  }
  .ant-collapse-header {
    background: #efefef;
  }
  .ant-table-small > .ant-table-content > .ant-table-body {
    margin: 0 !important;
  }
  #components-layout-demo-custom-trigger .trigger {
    line-height: 41px;
  }
  // 设定主菜单选择子菜单时，主菜单出现颜色变化
  .ant-menu-item-active, .ant-menu-item:hover, .ant-menu-submenu-active, .ant-menu-submenu-title:hover, .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open {
    color: #ccc;
  }

</style>
